module.exports = ".dataBlock{display:flex;flex-direction:column}.dataBlock>div{display:flex;flex-direction:row;justify-content:space-around}\n"